import { jsxs as u, jsx as s } from "react/jsx-runtime";
import { useState as z, useEffect as q } from "react";
import { addCoupon as B } from "../api/addCoupon.js";
import { removeCoupon as G } from "../api/removeCoupon.js";
import { CouponIcon as H } from "../../../assets/svgs/CouponIcon.js";
import { SuccessIcon as J } from "../../../assets/svgs/SuccessIcon.js";
const X = ({
  account: L,
  orderFormId: _,
  hasItemsInCart: x,
  isIO: D = !1,
  item: l,
  firstCouponName: c,
  secondCouponName: d,
  replaceCoupon: f,
  setView: j,
  setActiveRule: N,
  setDataItem: i,
  setFirstCouponName: t,
  setSecondCouponName: w,
  setReplaceCoupon: y,
  setAlert: m,
  setType: p,
  setIsCloseModalEmpty: k,
  genericTaggingEvent: o
}) => {
  const [b, r] = z(!1), [A, h] = z(!1);
  q(() => {
    d.toLowerCase() !== l.couponName.toLowerCase() && r(!1), c && !d && c.toLowerCase() === l.couponName.toLowerCase() && r(!0), c && d && f && d.toLowerCase() === l.couponName.toLowerCase() && R(d);
  }, [c, d, f]);
  const R = async (a) => {
    if (x)
      try {
        if (!c || c && f) {
          h(!0);
          const V = await B(L, _, a);
          y(!1), t(a), w(""), V.error.length <= 0 ? (o == null || o("discount_coupon", {
            name: "cupom aplicado",
            cupomName: a
          }), p("success"), r(!0), D && window.location.reload()) : (o == null || o("discount_coupon", {
            name: "cupom aplicando - cupom incorreto ou expirado",
            cupomName: a,
            objectError: V.error
          }), p("error"), r(!1), t("")), m(!0);
        } else
          w(a), j("overwrite-view");
      } catch {
        o == null || o("discount_coupon", {
          name: "problema na api",
          cupomName: a
        }), r(!1), p("error"), m(!0);
      } finally {
        h(!1);
      }
    else
      o == null || o("discount_coupon", {
        name: "Modal de cart vazio acionado"
      }), k(!0);
  }, M = async () => {
    if (x)
      try {
        h(!0), y(!1);
        const a = await G(L, _);
        a.error.length <= 0 ? (o == null || o("discount_coupon", {
          name: "cupom removido com sucesso",
          cupomName: c
        }), p("removed"), r(!1), t(""), w(""), D && window.location.reload()) : (o == null || o("discount_coupon", {
          name: "algum problema na remoção do cupom",
          cupomName: c,
          objectError: a.error
        }), p("error"), r(!0)), m(!0);
      } catch {
        o == null || o("discount_coupon", {
          name: "problema na api - na remoção do cupom",
          cupomName: c
        }), p("error"), r(!0), m(!0);
      } finally {
        h(!1);
      }
    else
      o == null || o("discount_coupon", {
        name: "Modal de cart vazio acionado"
      }), k(!0);
  }, $ = () => {
    N(!0), i(l), j("rules-view");
  };
  return /* @__PURE__ */ u("div", { className: `container-card-coupon ${b ? "active" : ""}`, children: [
    /* @__PURE__ */ u("div", { className: "text-container", children: [
      /* @__PURE__ */ u("div", { className: "container-title", children: [
        /* @__PURE__ */ s(H, { width: 20, height: 16 }),
        /* @__PURE__ */ s("h3", { className: "title", children: l.couponName })
      ] }),
      l.couponValue && /* @__PURE__ */ u("p", { className: "price-badge", children: [
        "- ",
        l.couponValue
      ] }),
      l.couponDescription && /* @__PURE__ */ s("h4", { className: "subtitle", children: l.couponDescription }),
      l.couponExpirationDate && /* @__PURE__ */ u("h4", { className: "subtitle", children: [
        "Válido até ",
        l.couponExpirationDate
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: "vertical-line" }),
    /* @__PURE__ */ u("div", { className: "buttons-container", children: [
      b && /* @__PURE__ */ u("button", { className: "applied-coupon", children: [
        /* @__PURE__ */ s("span", { className: "applied-coupon-span", children: /* @__PURE__ */ s(J, {}) }),
        "Aplicado"
      ] }),
      b ? /* @__PURE__ */ s(
        "button",
        {
          onClick: M,
          className: "remove-coupon",
          disabled: A,
          children: "Remover"
        }
      ) : /* @__PURE__ */ s(
        "button",
        {
          onClick: () => R(l.couponName),
          className: "apply-coupon",
          disabled: A,
          children: "Aplicar"
        }
      ),
      l.couponDescription && /* @__PURE__ */ s("a", { onClick: $, children: "Ver Regras" })
    ] })
  ] });
};
export {
  X as CouponCard
};
